export const SYSTEM_SUPERVISION_ROUTES = [
  {
    path: 'users/list',
    name: 'users-list',
    component: () => import('@/components/system-supervision/UsersList.component.vue'),
  },
  {
    path: 'users/:userId',
    name: 'user-details',
    component: () => import('@/components/system-supervision/UserView.component.vue'),
  },
  {
    path: 'users/add',
    name: 'users-add',
    component: () => import('@/components/system-supervision/UserAdd.component.vue'),
  },
  {
    path: 'users/edit/:userId',
    name: 'user-edit',
    component: () => import('@/components/system-supervision/UserAdd.component.vue'),
  },
  {
    path: 'users/:userId/rights/edit',
    name: 'user-right-edit',
    component: () => import('@/components/system-supervision/EditUserRights.component.vue'),
  },
];

export const SYSTEM_SUPERVISION_ROUTES_SCOPES_RIGHTS = {
  'users-list': '9.2.',
  'user-details': '9.2.',
  'users-add': '9.3.',
  'user-edit': '9.4.',
  'user-right-edit': '9.4.',
};
